import fetch from '@/plugin/axios'

// 印记产品分类列表
export function getPrintList (query) {
  return fetch({
    url: '/api/goods/stamp-categorys/list',
    method: 'Post',
    data: query
  })
}

// 新增
export function addPrintDetails (query) {
  return fetch({
    url: '/api/goods/stamp-categorys/add',
    method: 'Post',
    data: query
  })
}

// 获取详情列表
export function getDetailList (query) {
  return fetch({
    url: '/api/goods/stamp-categorys/' + query,
    method: 'Get'
  })
}

// 修改详情列表
export function updateDetailList (id, query) {
  return fetch({
    url: '/api/goods/stamp-categorys/update/' + id,
    method: 'Post',
    data: query
  })
}

// 上下架
export function upDownShelves (id, query) {
  return fetch({
    url: '/api/goods/stamp-categorys/status/' + id,
    method: 'Get',
    params: query
  })
}
